import axios from '@/libs/api.request'
var qs = require('qs');

export const login = ({ userName, password }) => {
    let data = {
        username: userName,
        password: password

    }
    data = qs.stringify(data)
    return axios.request({
        url: 'login-exit/login',
        data,
        method: 'post'
    })
}

export const getUserInfo = (token) => {
    // var data = {
    //     'access': ['userManagement', 'studentManagement', 'teacherManagement', 'senateManagement', 'classManagement', 'courseClear',
    //         'operationManagement', 'orderList', 'schoolOrder', 'systemManagement', 'roleList', 'adminList',
    //     ],
    // }
    // return data;
    return axios.request({
        url: '/role-management/get-user-info',
        method: 'post'
    })
}

export const logout = (token) => {
    return axios.request({
        url: 'logout',
        method: 'post'
    })
}